import * as React from 'react';

import { cn } from 'utils/shadcn';

export default function InfoCircleIcon(
  props: React.SVGProps<SVGSVGElement>
): React.JSX.Element {
  const { className, ...rest } = props;
  return (
    <svg
      viewBox='0 0 1024 1024'
      fill='currentColor'
      height='1em'
      width='1em'
      className={cn('lucide', className)} // Since this isn't a lucide icon, add lucide class to include it on icon styles
      {...rest}
    >
      <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z' />
      <path d='M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z' />
    </svg>
  );
}
